import React from 'react';
import '../layout/DocumentChatLayout.css';

export interface PdfPreviewActionButtonProps {
  label: string;
  onClick: () => void;
}

export default function PdfPreviewActionButton({ label, onClick }: PdfPreviewActionButtonProps) {
  return (
    <div className="wr-chat__preview-actions">
      <button type="button" className="wr-chat__preview-btn" onClick={onClick}>
        {label}
      </button>
    </div>
  );
}
